import { OptionType } from "elements";
import { InheritanceDetails } from "store/desktopDeviceSettingInheritance";
import {
  FormCheckbox,
  FormSelect,
  FormSlider,
  FormSliderAutoBtn
} from "../../Settings-Shared/DeviceSettingsComponents";
import { DesktopDeviceFormSetting } from "../DesktopDeviceSettings";
import { SettingProps } from "../hooks";
import {
  BooleanSettingNotEmptyProps,
  SettingEmptyProps,
  StringSettingNotEmptyProps
} from "../schemas/types";
import { generateC10String, getC10Value } from "../utilities/c10";

export type DesktopDeviceSettingProps = Pick<
  DesktopDeviceFormSetting,
  "revert"
> & {
  accessor: string;
  type: string;
  changed?: string;
  settings: SettingProps;
  desktopDeviceSettings: any;
  values:
    | SettingEmptyProps
    | StringSettingNotEmptyProps
    | BooleanSettingNotEmptyProps;
  disabled: boolean;
  hideDependency: boolean;
  dropdownOptions: OptionType[];
  showAutoEnableButton: boolean;
  tooltipText: string;
  inheritance?: InheritanceDetails;
  className?: string;
  fromPolicy?: boolean;
};

export const DesktopDeviceSetting: React.FC<DesktopDeviceSettingProps> = ({
  accessor,
  desktopDeviceSettings,
  values,
  hideDependency,
  settings,
  type,
  dropdownOptions,
  showAutoEnableButton,
  fromPolicy,
  ...rest
}) => {
  return (
    <div
      data-testid={`${accessor.split(".")[1]}`}
      className={`show-hide ${hideDependency ? "hide" : "show"}`}
    >
      {type === "checkbox" && <FormCheckbox {...settings} {...rest} />}
      {type === "dropdown" && (
        <FormSelect options={dropdownOptions} {...settings} {...rest} />
      )}
      {type === "slider" && (
        <FormSlider {...settings} {...rest} values={values}>
          {/* managing auto enabled sliders for policies poses some issues so we will not include them for now. */}
          {showAutoEnableButton && !fromPolicy && (
            <FormSliderAutoBtn
              {...getC10Value(
                desktopDeviceSettings,
                generateC10String(`${accessor}_auto_enabled`).split(".")
              )}
            />
          )}
        </FormSlider>
      )}
    </div>
  );
};
